import { createFileRoute, redirect } from "@tanstack/react-router";

// Legacy URL preservation: /birthday/request/howto was the reminders "Learn More" page
// ("Be a Birthday Hero!", the three easy ways). Its content merged into the public
// /reminders/birthday/add page (2026-09-28), so this only redirects.
export const Route = createFileRoute("/birthday_/request_/howto")({
  beforeLoad: () => {
    throw redirect({ to: "/reminders/birthday/add", replace: true });
  },
});
